module.exports = __webpack_public_path__ + "img/weather.64d3d800.jpg";